import React from 'react';
import {
  CardCategoryLabel,
  CardCategory,
} from '@/design-system/components/Basic/Card/CardCategoryLabel';

export interface CardLabelProps {
  className?: string;
  children?: React.ReactNode;
  cardType: 'mandatory' | 'offer';
}

const TYPE_TO_CATEGORY: Record<string, CardCategory> = {
  mandatory: CardCategory.MANDATORY,
  offer: CardCategory.OFFER,
};

export const PreventionCardLabel: React.FC<CardLabelProps> = ({
  className,
  children,
  cardType,
}) => (
  <CardCategoryLabel category={TYPE_TO_CATEGORY[cardType]} className={className}>
    {children}
  </CardCategoryLabel>
);
